import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

export default function ForgotPassword() {
  const { loginWithRedirect } = useAuth0();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Trigger Auth0 password reset
    await loginWithRedirect({
      authorizationParams: {
        screen_hint: 'reset-password',
        login_hint: email,
      }
    });
    setSent(true);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <p style={styles.brand}>VIRILITER</p>
        <h1 style={styles.title}>Reset Password</h1>
        <p style={styles.subtitle}>Enter your email and we'll send you a reset link.</p>

        {sent ? (
          <div style={styles.successBox}>
            <p style={styles.successText}>✓ Check your email for a reset link.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={styles.form}>
            <input
              style={styles.input}
              type="email"
              placeholder="Email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            <button style={styles.button} type="submit">
              Send Reset Link
            </button>
          </form>
        )}

        <p style={styles.link}>
          Remember your password?{' '}
          <Link to="/" style={styles.linkAccent}>Sign In</Link>
        </p>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: { minHeight: '100vh', backgroundColor: '#0A0F1E', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' },
  card: { width: '100%', maxWidth: '420px', display: 'flex', flexDirection: 'column', gap: '16px' },
  brand: { color: '#3B82F6', fontSize: '11px', letterSpacing: '6px', fontWeight: '700', textAlign: 'center', margin: 0 },
  title: { color: '#F1F5F9', fontSize: '34px', fontWeight: '800', textAlign: 'center', margin: 0 },
  subtitle: { color: '#475569', fontSize: '13px', textAlign: 'center', margin: 0 },
  form: { display: 'flex', flexDirection: 'column', gap: '12px' },
  input: { backgroundColor: '#0F172A', color: '#F1F5F9', padding: '16px', borderRadius: '12px', fontSize: '16px', border: '1px solid #1E293B', outline: 'none', width: '100%', boxSizing: 'border-box' },
  button: { backgroundColor: '#3B82F6', color: '#ffffff', padding: '18px', borderRadius: '12px', fontSize: '16px', fontWeight: '700', border: 'none', cursor: 'pointer', width: '100%' },
  successBox: { backgroundColor: '#0F172A', borderRadius: '12px', padding: '16px', border: '1px solid #22C55E' },
  successText: { color: '#22C55E', fontSize: '14px', textAlign: 'center', margin: 0 },
  link: { color: '#475569', textAlign: 'center', fontSize: '14px', margin: 0 },
  linkAccent: { color: '#3B82F6', fontWeight: '600', textDecoration: 'none' },
};